import { Component, OnInit } from '@angular/core';
import { PopoverRef } from '@vex/components/popover/popover/popover-ref';

@Component({
  selector: 'vex-inventory-tree-setting-diagram',
  templateUrl: './inventory-tree-setting-diagram.component.html',
  styleUrls: ['./inventory-tree-setting-diagram.component.scss']
})
export class InventoryTreeSettingDiagramComponent implements OnInit {

  isShowUserProvider: boolean = true;
  isShowServiceProvider: boolean = true;
  isShowNullValues: boolean = false;
  isShowAudit: boolean = true;
  callFrom: string = '';
  isShowAuditToggle = true;

  diagramSetting: any = {
    isShowUserProvider: true,
    isShowServiceProvider: true,
    isShowNullValues: false,
    isShowAudit: true
  };

  constructor(
    private popoverRef: PopoverRef<InventoryTreeSettingDiagramComponent>
  ) { }

  ngOnInit(): void {
    this.diagramSetting = this.popoverRef.data;
    this.callFrom = this.popoverRef.data?.callFrom;
    this.isShowAuditToggle = this.popoverRef.data?.isShowAuditToggle;
    this.getSettingData();
  }

  getSettingData() {
    this.isShowUserProvider = this.diagramSetting.isShowUserProvider;
    this.isShowServiceProvider = this.diagramSetting.isShowServiceProvider;
    this.isShowNullValues = this.diagramSetting.isShowNullValues;
    this.isShowAudit = this.diagramSetting.isShowAudit;
  }

  onToggleUserProvider(event) {
    this.diagramSetting.isShowUserProvider = event.checked;
  }

  onToggleServiceProvider(event) {
    this.diagramSetting.isShowServiceProvider = event.checked;
  }

  onToggleNullValues(event) {
    this.diagramSetting.isShowNullValues = event.checked;
  }

  onToggleAuditValues(event) {
    this.diagramSetting.isShowAudit = event.checked;
  }

  onReset() {
    this.diagramSetting.isShowUserProvider = true;
    this.diagramSetting.isShowServiceProvider = true;
    this.diagramSetting.isShowNullValues = false;
    this.diagramSetting.isShowAudit = true;
    this.getSettingData();
    this.onApplyChanges();
    this.popoverRef.close();
  }

  onApplyChanges() {
    this.popoverRef.close(this.diagramSetting);
  }

}
